export const containerStyles = `
  flex flex-col justify-between 
  h-full
  p-[20px]
  flex-1
`

export const headerContainerStyles = `
  flex flex-col items-center 
  gap-1
`

export const headerTextStyles = `
  text-lg-semibold
`

export const descriptionStyles = `
  text-sm-medium
`

export const bodyContainerStyles = `
  flex flex-col items-center justify-center self-center max-w-[776px]
`
